import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import { getDateToString } from '../../../utils/convert';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import ElementoModal from '../ElementoModal';
import ElementoEntidadGrid from '../ElementoEntidadGrid';


const ElementosGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idClaseElemento: 0,
        disabled: false,
        showMessage: false,
        showForm: false,
        modeFormEdit: false,
        rowForm: null,
        dataTagger: {
            showModal: false,
            idEntidad: null
        }, 
        list: [],
        listEntities: []
    });

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    const mount = () => {
        setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r' && x.idClaseElemento === props.data.idClaseElemento);
        return {...prevState,
            idCuenta: props.data.idCuenta,
            idClaseElemento: props.data.idClaseElemento,
            list: list,
            listEntities: (props.hasEntity) ? props.data.listEntities : []};
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoElemento'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoElemento',
          timeout: 0
        }
    });

    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickElementoAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickElementoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickElementoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickElementoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickElementoDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>   
                              </div>
    const cellE = ({row}) =>    <div className='action' {...row.getToggleRowExpandedProps()}>
                                <div className="link">
                                  {row.isExpanded ? 
                                    <span className="material-symbols-outlined icon-expanded">expand_more</span> :
                                    <span className="material-symbols-outlined">chevron_right</span>
                                  }
                                </div>
                              </div>

    const getDescTipoElemento = (id) => {
        const row = getRowEntidad('TipoElemento', id);
        return (row) ? row.nombre : '';
    }

    const tableColumnsBase = [
        { Header: 'Tipo elemento', Cell: (props) => getDescTipoElemento(props.value), accessor: 'idTipoElemento', width: '50%' },
        { Header: 'Cantidad', accessor: 'cantidad', width: '10%' },
        { Header: 'Fecha alta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaAlta', width: '15%' },
        { Header: 'Fecha baja', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaBaja', width: '15%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '8%', disableGlobalFilter: true, disableSortBy: true }
    ];
    const tableColumns = (props.hasEntity) ? [{ Header: '', Cell: cellE, id:'expnader', width: '2%', disableGlobalFilter: true, disableSortBy: true }, ...tableColumnsBase] : tableColumnsBase;

    const subComponent = ({row}) => (

        <div className='form-sub-component'>
          <div className='row'>
            <div className="col-12 col-lg-8 col-xl-6 p-top-15">
              <label className="form-label">Vínculos</label>
              <ElementoEntidadGrid
                  disabled={props.disabled}
                  data={{
                    idElemento: row.original.id,
                    list: row.original.elementoEntidades,
                    listEntities: state.listEntities
                  }}
                  onChange={(typeEntity, row) => {
                    props.onChange(typeEntity, row);
                  }}
              />
            </div>
          </div>
        </div>
    
      );

    //handles
    const handleClickElementoAdd = () => {
        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                idCuenta: state.idCuenta,
                idClaseElemento: state.idClaseElemento,
                idTipoElemento: 0,
                cantidad: 0,
                fechaAlta: null,
                fechaBaja: null,
                activo: true,
                elementoEntidades: [],
                state: 'a'
            };
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickElementoView = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickElementoModify = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }

    const handleClickElementoRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showMessage: true, rowForm: rowForm};
        });
    }

    const handleClickElementoDataTagger = (id) => {
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
        });
    }    

    //funciones
    function RemoveElemento(row) {
        row.state = 'r';
        props.onChange('Elemento', row);
    }

    function UpdateElemento(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        props.onChange('Elemento', row);
    }

    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalRedux
                title="Información adicional de Elementos"
                processKey={props.processKey}
                entidad="Elemento"
                idEntidad={state.dataTagger.idEntidad}
                disabled={props.disabled}
                onDismiss={() => {
                setState(prevState => {
                    return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                });
                }}
            />
        }

        {state.showMessage && 
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de borrar el registro?"}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                }}
                onConfirm={() => {
                    const row = CloneObject(state.rowForm);
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                    RemoveElemento(row);
                }}
            />
        }

        {state.showForm && 
            <ElementoModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm,
                    listEntities: state.listEntities
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateElemento(row);
                  }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
            subComponent={subComponent}
        />

    </>
    );
}

ElementosGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
	hasEntity: bool,
    data: object.isRequired,
    onChange: func.isRequired
  };
  
  ElementosGrid.defaultProps = {
    disabled: false,
	hasEntity: false
  };

export default ElementosGrid;
